let irActive: number = 0;
let irNumber: number;

const bildPfadDefault: string = '/media/straehle-newworkelements-raum-grafik-00.jpg';
const bildPfadPrefix: string = '/media/straehle-newworkelements-raum-grafik-0';

function checkWidth(): number {
    return window.innerWidth ?? 0;
}

function deselectAll() {
    const map = document.querySelector<HTMLElement>('.new-work__map');
    if (!map) return;

    map.classList.remove('new-work__map--active');
    for (let i = 1; i <= irNumber; i++) map.classList.remove(`highlight-${i}`);

    document.querySelectorAll('.new-work__hotspot').forEach(h => h.classList.remove('new-work__hotspot--active'));
    document.querySelectorAll('.new-work__list-item').forEach(li => li.classList.remove('new-work__list-item--active'));
    document.querySelectorAll<HTMLElement>('.new-work__tooltip').forEach(t => t.style.display = 'none');

    const overlay = map.querySelector<HTMLElement>('.new-work__overlay');
    if (overlay) overlay.remove();

    const bgImg = map.querySelector<HTMLImageElement>('.new-work__image');
    if (bgImg) bgImg.src = bildPfadDefault;

    irActive = 0;

    updateSliderVisibility(); // Slider verstecken
}

function addOverlay() {
    const map = document.querySelector<HTMLElement>('.new-work__map');
    if (!map || map.querySelector('.new-work__overlay')) return;

    const overlay = document.createElement('div');
    overlay.classList.add('new-work__overlay');
    overlay.style.position = 'absolute';
    overlay.style.inset = '0';
    overlay.style.backgroundColor = 'rgba(0,0,0,0.1)';
    overlay.style.zIndex = '1';
    overlay.style.pointerEvents = 'auto';

    overlay.addEventListener('click', deselectAll);
    map.appendChild(overlay);
}

function changeHotspot(numberID: number) {
    if (irNumber === 0) return;

    // Wrap-around
    if (numberID <= 0) numberID = irNumber;
    if (numberID > irNumber) numberID = 1;

    deselectAll();

    const hotspot = document.querySelector<HTMLElement>(`.new-work__hotspot[data-id="${numberID}"]`);
    const listItem = document.querySelector<HTMLElement>(`.new-work__list-item[data-id="${numberID}"]`);
    const tooltip = document.querySelector<HTMLElement>(`.new-work__tooltip[data-id="${numberID}"]`);
    const map = document.querySelector<HTMLElement>('.new-work__map');

    if (hotspot) hotspot.classList.add('new-work__hotspot--active');
    if (listItem) listItem.classList.add('new-work__list-item--active');
    if (tooltip) tooltip.style.display = 'block';

    if (map) {
        map.classList.add('new-work__map--active');
        map.classList.add(`highlight-${numberID}`);

        const bgImg = map.querySelector<HTMLImageElement>('.new-work__image');
        if (bgImg) bgImg.src = `${bildPfadPrefix}${numberID}.jpg`;
    }

    addOverlay();
    irActive = numberID;

    updateSliderVisibility();
}

function updateSliderVisibility() {
    const activeItem = document.querySelector<HTMLElement>('.new-work__list-item--active');
    const backward = document.getElementById('newwork-backward');
    const forward = document.getElementById('newwork-forward');

    if (activeItem) {
        if (backward) backward.style.display = 'flex';
        if (forward) forward.style.display = 'flex';
    } else {
        if (backward) backward.style.display = 'none';
        if (forward) forward.style.display = 'none';
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const hotspots = document.querySelectorAll<HTMLElement>('.new-work__hotspot');
    const tooltips = document.querySelectorAll<HTMLElement>('.new-work__tooltip');
    const backward = document.getElementById('newwork-backward');
    const forward = document.getElementById('newwork-forward');

    irNumber = hotspots.length;

    updateSliderVisibility();

    hotspots.forEach(h => {
        h.addEventListener('click', () => {
            const id = parseInt(h.dataset.id ?? '0', 10);
            if (!id) return;

            if (checkWidth() > 1025 && h.classList.contains('new-work__hotspot--active')) {
                deselectAll();
                return;
            }
            changeHotspot(id);
        });
    });

    tooltips.forEach(t => {
        const closeBtn = t.querySelector<HTMLElement>('.new-work__tool-tip-close');
        closeBtn?.addEventListener('click', deselectAll);
    });

    backward?.addEventListener('click', () => {
        changeHotspot(irActive - 1);
    });

    forward?.addEventListener('click', () => {
        changeHotspot(irActive + 1);
    });

    if (checkWidth() < 900 && irNumber > 0) {
        changeHotspot(1);
    }
});

window.addEventListener('resize', () => {
    if (checkWidth() < 900 && irNumber > 0) {
        changeHotspot(1);
    }
    updateSliderVisibility();
});
